<template>
    <div class="similar-column-wrapper">
        <span class="link">
            {{ similarCount }}
            <Tips :text="tips" class="link-tip" :top="-33" />
        </span>

        <span class="i-recommend" @click.stop.self="recommendClick(row.addData)" v-if="row.addData.recommendSimilar">推荐</span>
    </div>
</template>

<script>
import Tips from "@/views/zhiji/bComponents/Tips";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";

export default {
    name: "similarColumn",
    props: ["row"],
    components: {
        Tips
    },
    data() {
        return {};
    },
    computed: {
        similarCount() {
            return this.row.addData.similarQuestion.value;
        },
        tips() {
            return this.row.addData.similarQuestion.tips;
        }
    },
    watch: {},
    methods: {
        recommendClick(data) {
            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    questionId: data.rowId,
                    sceneId: data.sceneId,
                    curPanel: "SimilarPanel",
                    currentTab: "RecommendSimilars",
                    hasRecommendSimilar: data.recommendSimilar,
                    closeHandler: () => {
                        this.$store.dispatch("zhiji/queryQuestionList", {});
                        this.$store.dispatch("zhiji/queryExtQuestionTotal", {});
                        this.$store.dispatch("zhiji/queryAnswersTotal", {});
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.similar-column-wrapper {
    display: flex;
    justify-content: space-between;
    max-width: 90px;
    box-sizing: border-box;

    .link {
        position: relative;

        &:hover {
            cursor: pointer;
            color: #2ec2ff;
            text-decoration: underline;

            .link-tip {
                display: inline-block;
            }
        }

        .link-tip {
            display: none;
        }
    }
    .i-recommend {
        // TODO 一期不上推荐问法
        display: none;
        cursor: pointer;
        padding: 4px 8px;
        font-size: 12px;
        color: #fff;
        background: #a4a4f7;
        box-shadow: 0 2px 6px 0 rgba(164, 164, 247, 0.3);
        border-radius: 4px;
        white-space: nowrap;
    }
}
</style>
